//
//
//
//
//
//
//
//
//
//
//
//
//

import AQButton from "@/components/Generics/AQButton/AQButton.vue";
import { mapActions, mapGetters } from "vuex";
import AQDialog from "@/components/Generics/AQDialog/AQDialog.vue";
import ContractDetails from "./UseTemplateSC/ContractDetails.vue";

export default {
    name: "StartFromScratch",
    components: {
        ContractDetails,
        AQDialog,
        AQButton
    },
    data() {
        return {
            scEditMode: "",
            finishBtn: true,
            dialogOpen: false,
            disabledParam: true,
            messageTitle: this.$t("smartContract.confirmationDialog.msg2"),
            titleDialog: this.$t("smartContract.confirmationDialog.title"),
            objectToSave: {},
            contract: {}
        };
    },
    computed: {
        ...mapGetters("main", ["getCurrentApplicationId"]),
        saveButtonLabel() {
            let labelBtn = "";
            switch (this.scEditMode) {
                case "create": {
                    labelBtn = this.$t("smartContract.createBtn");
                    localStorage.setItem("scEditMode", this.scEditMode);
                    break;
                }
                case "edit": {
                    labelBtn = this.$t("smartContract.editBtn");
                    break;
                }
                default:
                    break;
            }
            return labelBtn;
        }
    },
    created() {
        if (this.$route.params) {
            if (this.$route.params.currentContract) {
                this.contract = this.$route.params.currentContract;
            }
            if (this.$route.params.scEditMode) {
                this.scEditMode = this.$route.params.scEditMode;
            } else {
                this.scEditMode = localStorage.getItem("scEditMode");
            }
        }
    },
    methods: {
        ...mapActions("smartContractDesigner", ["saveSmartContract", "importSmartContract", "getSCNumber"]),
        backToCreateSmartContract() {
            // se va decomenta cand o sa intre si partea de Use Template
            // if (this.scEditMode === 'edit') {
            //   this.$router.push('/smartContractList');
            // } else {
            //   this.$router.push('/smartContractList/newSmartContract')
            // }
            if (!Object.keys(this.objectToSave).length) {
                this.$router.push("/smartContractList");
            } else {
                this.dialogOpen = true;
            }
        },
        okAction() {
            this.$router.push("/smartContractList");
        },
        cancelAction() {
            this.dialogOpen = false;
        },
        redirectToSmartList() {
            this.saveSmartContract(this.objectToSave).then(data => {
                if (data.status === 200) {
                    this.getSCNumber();
                    this.$router.push("/smartContractList");
                }
            });
        },
        colectData(value) {
            if (value.variable) {
                this.finishBtn = true;
                this.disabledParam = true;
            } else {
                this.finishBtn = false;
            }
            this.objectToSave = Object.keys(value.object).length ? this.prepareObjectForSave(value.object) : {};
        },
        prepareObjectForSave(value) {
            const objectToReturn = {
                id: value.id,
                applicationId: this.getCurrentApplicationId,
                name: value.name,
                description: value.description,
                address: value.address,
                networkId: Array.isArray(value.network) && value.network[0] ? value.network[0].value : value.network,
                credentialsId: Array.isArray(value.credentials) && value.credentials[0] ? value.credentials[0].value : value.credentials
            };
            if (value.type.length) {
                objectToReturn.bcTypeId = Array.isArray(value.type) ? value.type[0].value : value.type;
            }
            return objectToReturn;
        }

    }
};
